import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';
import { isDefined } from '../../../../../utils/utils';

@Component({
  selector: 'app-form-field-option',
  templateUrl: './option-form-field.component.html',
  styleUrls: ['./option-form-field.component.scss'],
  standalone: false,
})
export class OptionFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: any;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() editMode: boolean;

  isDisabled: boolean = false;

  matcher = new MyErrorStateMatcher();

  options: string[];

  constructor(private http: HttpClient) {
    super();
  }

  ngOnInit(): void {
    this.options = this.fieldConfig.options;
    if (this.fieldConfig.selectUrl) {
      this.http.get(this.fieldConfig.selectUrl).subscribe((d: string[]) => (this.options = d));
    }
    if (isDefined(this.formGroup) && isDefined(this.formGroup.get(this.fieldConfig.name))) {
      this.isDisabled = this.formGroup.get(this.fieldConfig.name).disabled;
    }
  }

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    return this.getValidatorConfig(v).condition(formControl);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  clearField() {
    this.getFormControl().reset();
  }
}
